module.exports = "/assets/45c6d56e4efa2b6d58763d2730cb32d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/HY.png
// module id = 2581
// module chunks = 0